import {
  getCustomer1Name,
  getCustomer2Name,
  hasCustomer2,
} from '@bulthaup/api/entities/customer';
import { Card, Divider, Grid, Group, Stack, Text, Title } from '@mantine/core';

import { RouterOutput } from '../../../../../../services/trpc';
import { label } from '../../../../../../utils/label';

interface InstallerProjectDetailsProps {
  project: RouterOutput['projects']['get'];
}

export function InstallerProjectDetails({
  project,
}: InstallerProjectDetailsProps) {
  const customer = project.customer;
  return (
    <Stack gap="xl">
      <div>
        <Title order={3} mb="md">
          Détails du Projet
        </Title>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <Stack gap="xs">
              <Group>
                <Text fw={500} c="dimmed">
                  Nom du projet:
                </Text>
                <Text>{project.name}</Text>
              </Group>
              <Group>
                <Text fw={500} c="dimmed">
                  Type de projet:
                </Text>
                <Text>{label(project.type)}</Text>
              </Group>
            </Stack>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <Stack gap="xs">
              <Group>
                <Text fw={500} c="dimmed">
                  Magasin:
                </Text>
                <Text>{project.shop.name}</Text>
              </Group>
              <Group>
                <Text fw={500} c="dimmed">
                  Vendeur:
                </Text>
                <Text>
                  {project.seller.firstName} {project.seller.lastName}
                </Text>
              </Group>
              {project.installer && (
                <Group>
                  <Text fw={500} c="dimmed">
                    Poseur:
                  </Text>
                  <Text>
                    {project.installer.firstName} {project.installer.lastName}
                  </Text>
                </Group>
              )}
            </Stack>
          </Grid.Col>
        </Grid>
      </div>

      <Divider />

      <div>
        <Title order={3} mb="md">
          Informations Client
        </Title>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <Stack gap="xs">
              <Group>
                <Text fw={500} c="dimmed">
                  Client 1:
                </Text>
                <Text>{getCustomer1Name(customer)}</Text>
              </Group>
              <Group>
                <Text fw={500} c="dimmed">
                  Email:
                </Text>
                <Text>{customer.customer1Email}</Text>
              </Group>
              <Group>
                <Text fw={500} c="dimmed">
                  Téléphone:
                </Text>
                <Text>{customer.customer1Phone}</Text>
              </Group>
            </Stack>
          </Grid.Col>

          {hasCustomer2(customer) && (
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <Stack gap="xs">
                <Group>
                  <Text fw={500} c="dimmed">
                    Client 2:
                  </Text>
                  <Text>{getCustomer2Name(customer)}</Text>
                </Group>
                <Group>
                  <Text fw={500} c="dimmed">
                    Email:
                  </Text>
                  <Text>{customer.customer2Email}</Text>
                </Group>
                <Group>
                  <Text fw={500} c="dimmed">
                    Téléphone:
                  </Text>
                  <Text>{customer.customer2Phone}</Text>
                </Group>
              </Stack>
            </Grid.Col>
          )}

          {customer.companyName && (
            <Grid.Col span={12}>
              <Group>
                <Text fw={500} c="dimmed">
                  Entreprise:
                </Text>
                <Text>{customer.companyName}</Text>
              </Group>
            </Grid.Col>
          )}
        </Grid>
      </div>

      {customer.contacts && customer.contacts.length > 0 && (
        <>
          <Divider />
          <div>
            <Title order={3} mb="md">
              Contacts
            </Title>
            <Grid>
              {customer.contacts.map((contact, index) => (
                <Grid.Col key={index} span={{ base: 12, sm: 6 }}>
                  <Card shadow="xs" p="md" withBorder>
                    <Stack gap="xs">
                      <Group>
                        <Text fw={500} c="dimmed">
                          Type:
                        </Text>
                        <Text>{contact.type}</Text>
                      </Group>
                      <Group>
                        <Text fw={500} c="dimmed">
                          Nom:
                        </Text>
                        <Text>
                          {contact.firstName} {contact.lastName}
                        </Text>
                      </Group>
                      {contact.email && (
                        <Group>
                          <Text fw={500} c="dimmed">
                            Email:
                          </Text>
                          <Text>{contact.email}</Text>
                        </Group>
                      )}
                      {contact.phone && (
                        <Group>
                          <Text fw={500} c="dimmed">
                            Téléphone:
                          </Text>
                          <Text>{contact.phone}</Text>
                        </Group>
                      )}
                      {contact.address && (
                        <Stack gap="xs" mt="xs">
                          <Group>
                            <Text fw={500} c="dimmed">
                              Adresse:
                            </Text>
                            <Text>{contact.address.address1}</Text>
                          </Group>
                          {contact.address.address2 && (
                            <Group>
                              <Text fw={500} c="dimmed">
                                Complément:
                              </Text>
                              <Text>{contact.address.address2}</Text>
                            </Group>
                          )}
                          <Group>
                            <Text fw={500} c="dimmed">
                              Ville:
                            </Text>
                            <Text>
                              {contact.address.postalCode}{' '}
                              {contact.address.city}
                            </Text>
                          </Group>
                        </Stack>
                      )}
                    </Stack>
                  </Card>
                </Grid.Col>
              ))}
            </Grid>
          </div>
        </>
      )}
    </Stack>
  );
}
